<template>
  <InfuseModal :title="t('e_connector.import.modal.import.title')" @close="emit('close')">
    <form ref="form" id="import-charging-stations" @submit.prevent="onImport()">
      <div class="flex max-h-[475px] max-w-[675px] flex-col gap-4 overflow-y-auto px-5">
        <div class="flex flex-col gap-4">
          <p class="text-sm text-neutral-800">
            {{ t('e_connector.import.modal.import.description') }}
          </p>

          <p
            v-permission="{ id: chargingStationPermissions.GET_CSV_IMPORT_TEMPLATE, hide: false }"
            class="text-sm text-neutral-800"
          >
            <i18n-t keypath="e_connector.import.modal.import.downloadTemplate">
              <a :href="downloadTemplateLink" class="underline" download>
                {{ t('e_connector.import.modal.import.downloadTemplateHere') }}
              </a>
            </i18n-t>
          </p>

          <hr class="my-3" />

          <div class="flex items-start gap-4">
            <InfuseField :label="t('e_connector.import.modal.field.file.label')" class="basis-full" size="small">
              <InfuseFileInput accept=".csv" v-model="selectedFile" :required="true" />
            </InfuseField>
          </div>
        </div>
      </div>
    </form>

    <template #actions>
      <InfuseButton color="secondary" @click="emit('close')">
        {{ t('e_connector.common.action.cancel') }}
      </InfuseButton>
      <InfuseButton type="submit" form="import-charging-stations" :disabled="loading" :loading="loading">
        {{ t('e_connector.common.action.import') }}
      </InfuseButton>
    </template>
  </InfuseModal>
</template>

<script setup lang="ts">
import { InfuseButton, InfuseField, InfuseFileInput, InfuseModal } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';
import { chargingStationPermissions, downloadCsvTemplateUrl } from '@infuse/api/e-connector/charging-station';
import { ref } from 'vue';
import { vPermission } from '@infuse/iam/permission/directives';

interface Props {
  loading: boolean;
}

interface Emits {
  (e: 'close'): void;
  (e: 'import', file: File): void;
}

withDefaults(defineProps<Props>(), {
  loading: false
});

const emit = defineEmits<Emits>();

const { t } = useI18n();

const downloadTemplateLink = downloadCsvTemplateUrl;
const selectedFile = ref<File>();

function onImport() {
  if (!selectedFile.value) {
    return;
  }

  emit('import', selectedFile.value);
}
</script>
